<template>
    <div class="container mt-nav z-index">
        <Head title="در حال انتقال"/>

        <div class="row">
            <div class="col-sm-10 col-lg-6  mx-auto">
                <div class="box__information">
                    <p class="text-sm text-white text-center">در حال انتقال به صفحه مورد نظر  . .
                        .</p>
                    <div class="text-sm text-white text-center">
                        <div class="spinner-grow text-danger" role="status">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import {Link} from "@inertiajs/inertia-vue3";
import LayoutFirstRegister from "../Shared/Layouts/LayoutFirstRegister";

export default {
    props: ['url'],
    layout: LayoutFirstRegister,
    components: {
        Head, Link
    },
    created() {
        window.location.href = this.url ?? 'login';
    }
}
</script>

<style scoped>

</style>
